import React, { useState, useEffect } from "react"
import { Route, RouteComponentProps, withRouter } from "react-router"
import { includes, size, get } from "lodash"
import APIs from "redux/apis"

import store from "redux/store"
import Header from "components/templates/main/Header"
import SymbolRegisterHeader from "components/templates/main/SymbolRegisterHeader"
import MainContents from "components/pages/main/mainContents"
import SymbolRegisterMainContents from "components/pages/main/symbolRegisterMainContents"
import {
  AUTH_ROUTE,
  MAIN_ROUTES,
  SymbolPage,
  TECH_CHART,
  SYMBOL_DETAIL,
} from "routes/routes"
import { UserStorage } from "utils/userStorage"
import { login, sessionLogin } from "redux/ducks/user"
import useNodeDistManager from "node-dist/useNodeDistManager"
import {
  useChangeMenuTrigger,
  changeMenuTrigger,
} from "components/actions/customHook/changeMenu"
import { setChartSession } from "../../atoms/chart/logic/chartSession"
import { setThemeFunction } from "../../../utils/util"
import { chartColorSetting } from "../../../redux/ducks/Chart"

const Main: React.FC<RouteComponentProps> = ({ location, history }) => {
  const isSymbolRegister = includes(location.pathname, "symbol")
  const isChartPage = includes(location.pathname, "chart")
  const isSymbolDetailPage = includes(location.pathname, "SymbolDetail")
  const isExternalPage = includes(location.pathname, "external/market")
  const isExternalPageHome = includes(location.pathname, "external/home")
  const hasUserInfo = !!size(UserStorage.User.get())
  const { changeMenuFlag, setChangeMenuFlag } = useChangeMenuTrigger()

  useEffect(() => {
    if (isSymbolRegister || isChartPage || isSymbolDetailPage || hasUserInfo) {
      return
    } else {
      ;(async () => {
        await store.dispatch(login("300", "3000016", "0000"))
        await history.push("top/summary")
      })()
    }
    if (!isSymbolRegister || !isChartPage || !isSymbolDetailPage) {
      const htmlClass = document.querySelector("html").classList
      htmlClass.add("bright")
      htmlClass.remove("dark")
      UserStorage.ThemeColor.set("bright")
      store.dispatch(chartColorSetting(UserStorage.TechChartColor.getWhite()))
    }
  }, [])

  useEffect(() => {
    const _rootClass = document.getElementById("root").classList
    const _htmlClass = document.querySelector("html").classList
    const _bodyClass = document.querySelector("body").classList
    isChartPage
      ? _rootClass.add("tech-chart-contents")
      : _rootClass.remove("tech-chart-contents")
    if (isExternalPage || isExternalPageHome) {
      _htmlClass.add("external")
      _bodyClass.add("external")
    } else {
      _htmlClass.remove("external")
      _bodyClass.remove("external")
    }
  }, [isChartPage, isExternalPage, isExternalPageHome])

  useEffect(() => {
    changeMenuFlag && setChangeMenuFlag(false)
  }, [changeMenuFlag])

  return isSymbolRegister ? (
    <SymbolRegisterMainContents route={SymbolPage} main={false} />
  ) : isChartPage ? (
    <Route
      path={TECH_CHART.techChart.path}
      component={TECH_CHART.techChart.component}
    />
  ) : isSymbolDetailPage ? (
    <Route
      path={SYMBOL_DETAIL.symbolDetail.path}
      component={SYMBOL_DETAIL.symbolDetail.component}
    />
  ) : isExternalPage ? (
    <Route
      path={AUTH_ROUTE.external.market.path}
      component={AUTH_ROUTE.external.market.component}
    />
  ) : isExternalPageHome ? (
    <Route
      path={AUTH_ROUTE.external.home.path}
      component={AUTH_ROUTE.external.home.component}
    />
  ) : (
    <>
      <changeMenuTrigger.Provider value={{ changeMenuFlag, setChangeMenuFlag }}>
        <Header path={location.pathname}>
          <MainContents route={MAIN_ROUTES} main={false} />
        </Header>
      </changeMenuTrigger.Provider>
      {/*<Route*/}
      {/*  path={AUTH_ROUTE.login.path}*/}
      {/*  component={AUTH_ROUTE.login.component}*/}
      {/*/>*/}
      <Route path={AUTH_ROUTE.sso.path} component={AUTH_ROUTE.sso.component} />
    </>
  )
}

export default withRouter(Main)
